<template>
  <div>
    <vue-headful v-if="page.fields.seo" :title="page.fields.seo.seo_title" :description="page.fields.seo.meta_description" />
    <SeoSchema v-if="page.fields.seo" :json="page.fields.seo.schema" />
    <div id="wonder-wrapper" class="wonder-wrapper">
      <div style="height: 100%">
        <div class="fullpage-container">
          <div class="fullpage-wp" v-fullpage="opts" ref="wonderslides">
            <section class="banner page page-1">
              <div id="hero">
                <div
                  class="layer-bg layer"
                  data-depth="0"
                  data-type="parallax"
                ></div>
                <div
                  class="layer-1 layer"
                  data-depth="0"
                  data-type="parallax"
                ></div>
                <div
                  class="layer-2 layer"
                  data-depth=".08"
                  data-type="parallax"
                ></div>
                <div
                  class="layer-3 layer"
                  data-depth="-.06"
                  data-type="parallax"
                ></div>
                <div
                  class="layer-4 layer"
                  data-depth="-.2"
                  data-type="parallax"
                ></div>
                <div class="layer-5">
                  <img
                    src="/images/natural-wonders/mouse-down-icon.png"
                    alt="Mouse down icon"
                    class=""
                  />
                </div>
                <h1 class="h1-natural-wonders">
                  <span>Alabama Natural Wonders</span>
                  <img
                    src="/images/natural-wonders/alabama-natural-wonders.svg"
                    :alt="page.fields.bannerid_alt_text"
                    class="al-natural-wonders"
                  />
                </h1>
              </div>
              <div id="hero-mobile">
                <h1 class="h1-natural-wonders">
                  <span>Alabama Natural Wonders</span>
                  <img
                    src="/images/natural-wonders/alabama-natural-wonders.svg"
                    :alt="page.fields.bannerid_alt_text"
                    class="al-natural-wonders"
                  />
                </h1>
              </div>
            </section>
            <div class="container page page-2">
              <div
                class="row text-md-center heading-padding-mobile d-flex align-items-end"
              >
                <div class="col-lg-4 col-md-12 mt-5 natural-badge">
                  <img
                    :src="page.fields.badge"
                    class="badge-img"
                    :alt="page.fields.badge_alt_text"
                    role="presentation"
                  />
                </div>
                <div
                  class="col-lg-8 col-md-12 mt-5 page-description text-md-center"
                >
                  <h2 v-html="page.fields.title"></h2>
                  <p v-html="page.fields.intro"></p>
                </div>
              </div>
            </div>
            <div
              class="page"
              :class="'page-' + (index + 3)"
              v-for="(wonder, index) in wonders"
              :key="index"
            >
              <div class="content-block" :id="wonder.id">
                <figure
                  v-bind:class="`${wonder.imageClass}`"
                  class="img-container"
                >
                  <img
                    class="natural-wonders-img"
                    :alt="wonder.imageAlt"
                    role="presentation"
                    v-bind:class="`${wonder.imageClass}`"
                    :src="`${wonder.image}`"
                  />
                  <div
                    v-bind:class="{
                      'description-wrapper-left':
                        wonder.imageClass === 'portrait',
                      'description-wrapper-right':
                        wonder.imageClass === 'landscape',
                    }"
                  >
                    <h3 class="mb-4">{{ wonder.name }}</h3>
                    <div class="mb-4" v-html="wonder.description"></div>
                    <div
                      class="row justify-content-md-center button-row mb-5-m"
                    >
                      <div class="">
                        <router-link
                          :to="`${wonder.slug}`"
                          class="wonder-button mobile"
                          >Find Out More</router-link
                        >
                      </div>
                      <div class="">
                        <router-link
                          to="/places-to-go/map"
                          class="wonder-button desktop"
                          >View on Map</router-link
                        >
                      </div>
                    </div>
                  </div>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-navbar
        class="flex-column floating-menu-wrapper"
        v-if="currentIndex >= 1"
      >
        <b-nav pills vertical>
          <b-nav-item class="nav-pills" @click="navigate(-1)">
            <ul
              class="sticky-nav navbar flex-column navbar-light navbar-expand"
            >
              <li
                pills
                vertical
                class="nav nav-container nav-pills flex-column"
              >
                <div
                  class="nav-item nav-link"
                  :class="{ active: 1 == currentIndex }"
                >
                  <div class="inner-dot">
                    <div class="outer-dot"></div>
                  </div>
                  <div class="title-box-container">
                    <div class="title-box">
                      <div class="title">Alabama Natural Wonders</div>
                    </div>
                  </div>
                  <div class="vertical-line"></div>
                </div>
              </li>
            </ul>
          </b-nav-item>
          <b-nav-item
            class="nav-pills"
            v-for="(wonder, index) in wonders"
            :key="index"
            @click="navigate(index)"
          >
            <ul
              class="sticky-nav navbar flex-column navbar-light navbar-expand"
            >
              <li
                pills
                vertical
                class="nav nav-container nav-pills flex-column"
              >
                <div
                  class="nav-item nav-link"
                  :class="{ active: index == currentIndex - 2 }"
                >
                  <div class="inner-dot">
                    <div class="outer-dot"></div>
                  </div>
                  <div class="title-box-container">
                    <div class="title-box">
                      <div class="title">{{ wonder.name }}</div>
                    </div>
                  </div>
                  <div class="vertical-line"></div>
                </div>
              </li>
            </ul>
          </b-nav-item>
        </b-nav>
      </b-navbar>
    </div>
    <section class="mobile-nav">
      <div
        class="natural-wonders-nav-mobile"
        v-bind:class="{ 'mobile-close': !button_active_state }"
      >
        <div
          id="nav-icon-nw"
          v-on:click="button_active_state = !button_active_state"
          v-bind:class="{ open: button_active_state }"
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
        <h2 class="mobile-nav-title">List of Wonders</h2>
      </div>
      <div
        class="default-nw-menu-container"
        v-bind:class="{ 'mobile-close': !button_active_state }"
      >
        <div class="menu">
          <div
            class="mobile-wonders"
            v-for="(wonder, index) in wonders"
            :key="index"
          >
            <div
              v-on:click="button_active_state = false"
              v-bind:class="{ closed: button_active_state }"
              class="mobile-content-block"
            >
              <span
                ><a
                  :href="`#${wonder.id}`"
                  :class="{ active: index == currentIndex - 2 }"
                  >{{ wonder.name }}</a
                ></span
              >
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import Butter from 'buttercms';
import Mobile from 'is-mobile';
import Banner from '@/components/Common/Banner.vue';

export const butter = Butter('eb418357164849860c223876bb84811162582149');

@Component({
  destroyed() {
    window.removeEventListener('scroll', this.headerScroll);
  },
  data() {
    return {
      button_active_state: false,
      page: {
        fields: {},
      },
      showFade: false,
      showMobileMenu: false,
      wonders: [],
      wondersFromButter: [],
      currentIndex: 0,
      opts: {
        start: 0,
        dir: 'v',
        duration: 500,
        afterChange: (currentSlideEl, currentIndex) => {
          this.currentIndex = currentIndex;
        },
      },
    };
  },
  components: {
    Banner,
  },
  methods: {
    navigate(index) {
      this.$refs.wonderslides.$fullpage.moveTo(index + 2, true, true);
    },
    getPage() {
      butter.page
        .retrieve('*', 'natural-wonders', {
          preview: `${process.env.VUE_APP_BUTTER_PREVIEW}`,
        })
        .then(async (res) => {
          this.page = await res.data.data;
          this.wondersFromButter = this.page.fields.natural_wonders;
          this.wondersFromButter.forEach((wo) => {
            const wonder = {};
            wonder.name = wo.name;
            wonder.image = wo.imageurl;
            wonder.imageAlt = wo.imagealt;
            wonder.imageClass = wo.imageclass;
            wonder.description = wo.description;
            wonder.slug = wo.slug;
            wonder.id = wonder.name.replace(/\s+/g, '-').toLowerCase();
            this.wonders.push(wonder);
          });
        })
        .catch((res) => {
          console.log(res);
        })
        .then(() => {
          if (Mobile()) {
            const element = document.getElementById('wonder-wrapper');
            element.classList.remove('wonder-wrapper');

            this.$refs.wonderslides.$fullpage.setDisabled(true);
            const vNavimg = document.getElementsByClassName('page');
            for (let i = 0; i < vNavimg.length; i++) {
              vNavimg[i].removeAttribute('style');
            }
          } else {
            const element = document.getElementById('wonder-wrapper');
            element.classList.add('wonder-wrapper');

            this.$refs.wonderslides.$fullpage.setDisabled(false);

            this.$refs.wonderslides.$fullpage.update();
          }
        });
    },
    headerScroll() {
      let depth;
      let i;
      let layer;
      let len;
      let movement;
      let translate3d;
      const topDistance = window.pageYOffset;
      const layers = document.querySelectorAll("[data-type='parallax']");
      for (i = 0, len = layers.length; i < len; i++) {
        layer = layers[i];
        depth = layer.getAttribute('data-depth');
        movement = -(topDistance * depth);
        translate3d = `translate3d(0, ${movement}px, 0)`;
        layer.style['-webkit-transform'] = translate3d;
        layer.style['-moz-transform'] = translate3d;
        layer.style['-ms-transform'] = translate3d;
        layer.style['-o-transform'] = translate3d;
        layer.style.transform = translate3d;
      }
    },
  },
  async created() {
    await this.getPage();
    window.addEventListener('scroll', this.headerScroll);
  },
})
class NaturalWonders extends Vue {}

export default NaturalWonders;
</script>

<style lang="scss" scoped>
.wonder-wrapper {
  position: absolute;
  top: 151px;
  left: 0px;
  right: 0px;
  bottom: 0px;
}
.mb-5-m {
  margin-bottom: 0px;
}
.floating-menu-wrapper {
  position: fixed;
  top: 35px;
  z-index: 9;
  max-height: 715px !important;
  width: 50px;
  left: 50px;
}
.natural-wonders-img.landscape {
  float: left;
  height: 90%;
  width: 90%;
}
.content-block {
  height: 88%;
  overflow: hidden;
  margin: 50px 150px 0px 200px;
}
.natural-wonders-img.portrait {
  float: right;
  margin-right: 20%;
  height: 80vh;
}
#hero {
  height: 100%;
  overflow: hidden;
  position: relative;
}

#content {
  background-color: white;
}

.outer-dot {
  display: none;
}

.layer {
  background-position: bottom center;
  background-size: auto;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
}

#hero-mobile {
  display: none;
  background: url('/images/natural-wonders/full_illustration.png') no-repeat
    right bottom/cover;
  height: 420px;
}

h1 span {
  clip: rect(1px, 1px, 1px, 1px);
  clip-path: inset(50%);
  height: 1px;
  width: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
}

.h1-natural-wonders img {
  height: 345px;
  left: calc(50% - 361px);
  position: absolute;
  top: calc(50% - 172px);
}

#hero-mobile .h1-natural-wonders img {
  height: 145px;
  left: inherit;
  position: relative;
}

.layer {
  min-height: 800px;
}
.page {
  height: 100% !important;
}

.layer-bg {
  background-image: url('/images/natural-wonders/layer-bg.png');
  background-size: 130%;
}

.layer-1 {
  background-image: url('/images/natural-wonders/layer-01.png');
  background-position: right 80%;
  background-size: 53vh;
}

.layer-2 {
  background-image: url('/images/natural-wonders/layer-02.png');
  background-position: right bottom;
  background-size: 400px;
}

.layer-3 {
  background-image: url('/images/natural-wonders/layer-03.png');
  background-position: 100% 600px;
  background-size: 960px;
}

.layer-4 {
  background-image: url('/images/natural-wonders/layer-04.svg');
  background-position: -20% 70%;
  background-size: 950px;
}
.layer-5 {
  position: absolute;
  left: calc(50% - 29px);
  bottom: 15%;
  animation: MoveUpDown 2s linear infinite;
}

@keyframes MoveUpDown {
  0%,
  100% {
    bottom: 20px;
  }
  50% {
    bottom: 40px;
  }
}

.nav-items.nav-pills {
  line-height: auto;
  padding: 0;
}
.wonder {
  justify-content: start;
}
.description-wrapper-left {
  border-radius: 4px;
  border: solid 2px #4e97b2;
  background-color: #fff;
  color: #2c3e50;
  font-size: 16px;
  height: auto;
  margin-top: 10%;
  padding: 30px;
  position: absolute;
  right: 45%;
  text-align: left;
  width: 395px;
}
.description-wrapper-right {
  border-radius: 4px;
  border: solid 2px #4e97b2;
  background-color: #fff;
  color: #2c3e50;
  font-size: 16px;
  height: auto;
  margin-top: 10%;
  padding: 20px;
  position: absolute;
  left: 65%;
  text-align: left;
  width: 395px;
}
@media only screen and (max-width: 1440px) {
  .natural-wonders-img.portrait {
    float: right;
    right: 30%;
  }
  .description-wrapper-left {
    right: 50% !important;
  }
}
@media only screen and (max-width: 1366px) {
  .description-wrapper-left {
    margin-top: 5% !important;
  }
  .natural-wonders-img.landscape {
    width: 100%;
  }
  .content-block {
    margin: 50px 150px 0px 150px;
  }
  .layer-5 {
    top: 68%;
    animation: MoveUpDown 2s linear infinite;
  }
  @keyframes MoveUpDown {
    0%,
    100% {
      top: 68%;
    }
    50% {
      top: 65%;
    }
  }
  .h1-natural-wonders img {
    height: 300px;
    left: calc(50% - 330px);
    position: absolute;
    top: calc(50% - 247px);
  }
  #hero {
    height: 98vh;
  }
  .layer-2 {
    background-position: right 200px;
    background-size: 400px;
  }
  .layer-3 {
    background-position: 102% 470px;
    background-size: 960px;
  }
  .layer-4 {
    background-position: -35% 70%;
  }
  .description-wrapper-right {
    margin-top: 1% !important;
  }
  .description-wrapper-left {
    margin-top: 1% !important;
  }
}

@media only screen and (max-width: 1025px) {
  #hero {
    display: none;
  }

  #hero-mobile {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.relative {
  position: relative;
}
.nav-column {
  margin-left: 200px;
  position: absolute;
}
.navbar {
  position: absolute;
}
.vertical-line {
  border: solid 1px #4e97b2;
  height: 40px;
  margin-left: auto;
  margin-right: auto;
  margin-top: -26px;
  width: 1px;
}
.sticky-nav {
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0px;
  z-index: 9999999999;
}
.nav-pills .nav-link.active {
  color: transparent;
  background-color: transparent;
}
.mobile-nav {
  display: none;
}
.default-nw-menu-container {
  -webkit-box-shadow: 0px 8px 5px 0px rgba(0, 0, 0, 0.14);
  -moz-box-shadow: 0px 8px 5px 0px rgba(0, 0, 0, 0.14);
  box-shadow: 0px 8px 5px 0px rgba(0, 0, 0, 0.14);
}
ul > li:last-of-type > a > ul > li > div > div.vertical-line {
  height: 0px;
  border: solid 1px #ffffff;
}
a.nav-link:focus {
  outline: none !important;
}
.title-box-container {
  display: none;
  margin-left: 15px;
  z-index: 9999999999;
}
.outer-dot {
  width: 27px;
  height: 27px;
  border: solid 2px #4e97b2;
  border-radius: 50%;
}
.inner-dot {
  background-color: #4e97b2;
  display: inline-block;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  margin-left: auto;
  margin-right: auto;
  position: relative;

  &:hover,
  &:active,
  &:focus {
    width: 16px;
    height: 16px;
    margin-top: 3px;
  }
}
.inner-dot:hover + .title-box-container {
  display: inline-block;
  margin-top: -20px;
  position: absolute;
}
.nav-item {
  height: 28px;
}
.nav-item > a {
  margin-top: 0px;
}
.nav-pills .nav-link {
  padding: 0px !important;
}
.nav-item.active .outer-dot {
  display: block;
  position: relative;
  top: -9px;
  left: -8px;
}
.nav-item.active:hover .outer-dot {
  display: none;
}
.title-box {
  width: 217px;
  height: 55px;
  background-color: #4e97b2;
  border-radius: 5px;
  color: #fff;
  display: block;
  font-size: 15px;
  margin-top: 12px;
  position: relative;
  text-align: center;
}
.title-box:before {
  content: '';
  position: absolute;
  top: 7%;
  left: 0%;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 42px 0px 0px 35px;
  border-color: #4e97b2 transparent transparent transparent;
  transform: rotate(-135deg);
}
.title {
  line-height: 55px;
  text-align: center;
}
.button-row {
  margin-top: 45px;
  margin-bottom: 15px;
}
.natural-badge {
  width: 400px;
  margin-top: 100px !important;
}
.page-header {
  margin-bottom: 150px;
}
.page-description {
  text-align: left;
  float: right;
  margin-top: 125px !important;
}
.description {
  padding-top: 30px;
  line-height: 30px;
}
.natural-wonders {
  position: relative;
  overflow-y: visible;
  scroll-snap-type: y mandatory;
  scroll-padding-top: 26vh;
}

.wonder-button {
  background-color: #fff;
  border: solid 1px #173945;
  border-radius: var(--spacing-xxs);
  color: #2c3e50;
  font-family: 'IdealSans-Medium';
  font-size: 14px;
  margin-right: 20px;
  min-height: 50px;
  padding: 10px 30px 10px 30px;
  position: relative;
  -webkit-transition: background-color 500ms;
  transition: background-color 500ms;
  text-decoration: underline;

  &:hover,
  &:active,
  &:focus {
    background-color: #d6e7ee;
    color: #4e97b2;
  }
}
@media only screen and (max-width: 1024px) {
  .natural-wonders {
    height: auto;
    overflow-y: visible !important;
  }
  .natural-wonders-img {
    margin-top: 100px;
  }
  .description-wrapper-left {
    margin-top: 22% !important;
    left: 50px !important;
  }
  .description-wrapper-right {
    margin-top: 30% !important;
    left: 54%;
  }
  .content-block {
    margin: 0px 100px 0px 100px;
  }
  .nav-item {
    height: 26px;
  }
}
@media only screen and (max-width: 823px) {
  .button-center {
    display: inline-block;
  }
  .page-header {
    margin-bottom: 0px;
  }
  .content-block {
    margin: 0px 0px 0px 0px;
  }
}
@media only screen and (max-width: 768px) {
  .page-header {
    margin-bottom: 0px;
  }
  .page-description {
    font-size: 22px;
  }
  .natural-wonders-img.portrait {
    margin-top: 0px;
    max-height: 150px;
    float: right;
    margin-left: 10px;
  }
  .page {
    height: 100% !important;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .natural-wonders-img.landscape {
    float: left;
    height: 90%;
    width: 90%;
    margin-top: 0px;
  }
  .content-block {
    height: 88%;
    overflow: hidden;
    margin: 50px 0px 0px 150px;
  }
  .heading-padding-mobile {
    padding: 0 110px;
  }
  .natural-badge {
    width: 400px;
    margin-top: 30px !important;
  }
  .natural-wonders-img.portrait {
    float: right;
    margin-right: 20%;
    height: 80vh;
    max-height: 600px;
    right: 5%;
    margin-right: 5%;
  }
  .description-wrapper-left {
    left: 140px !important;
    margin-top: 38% !important;
  }
  .description-wrapper-right {
    left: 45%;
  }
  .badge-img {
    width: 200px;
  }
  .page-description {
    margin-top: 10px !important;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
  .natural-wonders-img.landscape {
    float: left;
    height: 90%;
    width: 72%;
    margin-top: 0px;
  }
  .heading-padding-mobile {
    margin-top: 100px;
  }
  .content-block {
    height: 88%;
    overflow: hidden;
    margin: 50px 0px 0px 150px;
  }
  .nav-item {
    height: 24px;
  }
  .natural-wonders-img.portrait {
    float: right;
    margin-right: 20%;
    height: 80vh;
    max-height: 600px;
    right: 16%;
    margin-right: 16%;
    margin-top: 0px;
  }
  .description-wrapper-left {
    left: 150px !important;
    margin-top: 1% !important;
  }
  .description-wrapper-right {
    left: 55%;
    margin-top: 1% !important;
  }
  .badge-img {
    width: 200px;
  }
  .page-description {
    margin-top: 10px !important;
  }
}
@media only screen and (max-width: 767px) {
  .button-row {
    float: left;
    margin-bottom: 0px;
    margin-top: 10px;
  }
  .desktop {
    display: none;
  }
  .wonder.landscape {
    height: auto;
  }
  .wonder.portrait {
    height: auto;
  }

  .description-wrapper-left,
  .description-wrapper-right {
    background-color: transparent;
    border: none;
    bottom: 10px;
    float: none;
    font-size: 22px;
    height: auto;
    left: 0 !important;
    margin-top: 20px !important;
    padding: 18px;
    position: relative;
    width: 100%;
  }
  .natural-badge {
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 300px;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
    margin-top: 0px !important;
  }
  .natural-wonders {
    margin-left: 0px;
    scroll-snap-type: none;
  }
  .mb-5-m {
    margin-bottom: 85px;
  }
  .natural-wonders-img.landscape {
    float: none;
    width: 100%;
    padding-right: 10px;
    padding-left: 10px;
    margin-top: 0px;
  }
  .natural-wonders-img.portrait {
    margin-bottom: 0px;
    right: 0px;
    padding-right: 10px;
    padding-left: 10px;
    max-height: 100% !important;
    margin-bottom: 40px;
    clear: both;
    margin-right: auto;
    float: none;
    margin-left: 0px;
    width: 100%;
  }
  .floating-menu-wrapper {
    display: none;
  }
  .page-description {
    font-size: 28px;
    margin-top: 20px !important;
  }
  .wonder {
    height: auto;
    margin-bottom: 60px;
  }
  // Mobile Nav for Natural Wonders
  .mobile-nav {
    display: block;
    z-index: 999999;
  }
  .mobile-menu-header {
    width: 50px;
    height: 50px;
  }
  .dropdown-menu-wrapper {
    position: relative;
    padding: 120px;
  }
  .default-nw-menu-container {
    background-color: #ffffff;
    bottom: 0;
    display: block;
    line-height: 22px;
    margin-bottom: 15px;
    padding-top: 20px;
    position: fixed;
    top: 50px;
    width: 100%;
    z-index: 999;
  }
  .default-nw-menu-container.mobile-close {
    display: none;
  }
  .natural-wonders-nav-mobile {
    display: block;
    background-color: #fff;
    bottom: 0px;
    box-shadow: -1px 8px 5px 0px rgba(0, 0, 0, 0.14);
    height: 80px;
    position: fixed;
    top: 0;
    bottom: auto;
    width: 100%;
    z-index: 999999;
  }
  .natural-wonders-nav-mobile.mobile-close {
    display: block;
    background-color: #fff;
    bottom: 0px;
    top: auto;
    height: 80px;
    position: fixed;
    width: 100%;
    z-index: 999999;
  }
  .mobile-nav-title {
    color: #4e97b2;
    float: left;
    font-family: 'IdealSans-Book';
    margin-top: 18px;
  }
  .mobile-wonders {
    margin-top: 12px;
  }

  #nav-icon-nw {
    width: 60px;
    height: 45px;
    position: relative;
    margin: 15px 15px;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: 0.5s ease-in-out;
    -moz-transition: 0.5s ease-in-out;
    -o-transition: 0.5s ease-in-out;
    transition: 0.5s ease-in-out;
    cursor: pointer;
    float: left;
  }

  #nav-icon-nw span {
    display: block;
    position: absolute;
    height: 9px;
    width: 100%;
    background: #4e97b2;
    border-radius: 9px;
    opacity: 1;
    left: 0;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: 0.25s ease-in-out;
    -moz-transition: 0.25s ease-in-out;
    -o-transition: 0.25s ease-in-out;
    transition: 0.25s ease-in-out;
  }

  #nav-icon-nw span:nth-child(1) {
    top: 0px;
    -webkit-transform-origin: left center;
    -moz-transform-origin: left center;
    -o-transform-origin: left center;
    transform-origin: left center;
  }

  #nav-icon-nw span:nth-child(2) {
    top: 18px;
    -webkit-transform-origin: left center;
    -moz-transform-origin: left center;
    -o-transform-origin: left center;
    transform-origin: left center;
  }

  #nav-icon-nw span:nth-child(3) {
    top: 36px;
    -webkit-transform-origin: left center;
    -moz-transform-origin: left center;
    -o-transform-origin: left center;
    transform-origin: left center;
  }

  #nav-icon-nw.open span:nth-child(1) {
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
    top: -3px;
    left: 8px;
  }

  #nav-icon-nw.open span:nth-child(2) {
    width: 0%;
    opacity: 0;
  }

  #nav-icon-nw.open span:nth-child(3) {
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    transform: rotate(-45deg);
    top: 39px;
    left: 8px;
  }
}
@media only screen and (max-width: 737px) {
  // .banner {
  //   //height: 270px;
  // }
}
@media only screen and (max-width: 640px) {
  // .banner {
  //   //height: 225px;
  // }
}
@media only screen and (max-width: 568px) {
  // .banner {
  //   //height: 185px;
  // }
}
@media only screen and (max-width: 414px) {
  .banner {
    background-position: -60% 0;
    //height: 85vh;
  }
  .natural-wonders-img-left {
    min-height: 200px;
  }
}
</style>
